<template>
  <v-container fluid class="b-container">
      <v-row class="pl-4">
          <h3>Coupon Details Page</h3>
      </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
export default {
    name: "CouponDetails",

    methods: {
        ...mapActions(["getCouponDetails"]),
    },

    mounted(){
        this.getCouponDetails(this.$route.params.couponId)
    }
}
</script>